var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":_vm.title,"disabled":!_vm.title}},[_c('div',{staticClass:"app-icon-button",class:{
      'app-icon-button-disabled':_vm.disabled
    },style:(`background:${!_vm.active?'none':''}`)},[_c('BaseIcon',{staticClass:"app-icon",style:({'border-color':_vm.active?'#fff':'#888'}),attrs:{"icon":_vm.icon,"size":_vm.size,"color":_vm.active?'#fff':'#888'},on:{"click":function($event){return _vm.$emit('on-click')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }